export const en = {
  integrationsPage: {
    meta: { title: 'Integrations' },
    hero: {
      eyebrow: 'Integrations',
      heading_main: 'Meet your team',
      heading_em: 'where they already work',
      lead: 'Purposely lives inside Slack and Microsoft Teams, so volunteering invites, reminders, and sign-ups happen in the channels your team checks every day. No new app to install.',
    },
    availStrip: 'Both integrations are live and ready to install — live in under two minutes.',
    slack: {
      name: 'Slack',
      status: 'Live',
      headline: 'Volunteering opportunities, posted to the channels your team already lives in',
      desc: 'Connect Purposely to your Slack workspace and our agent will post curated shifts, send personal nudges, and capture RSVPs — all without anyone leaving Slack.',
      features: [
        'Post events to any channel — by team, location or cause',
        'Event updates pushed automatically',
        'DM reminders before each shift',
      ],
      cta: 'Add to Slack →',
      visual: {
        channel: '# volunteer-updates',
        meta: '12 members · today',
        msgName: 'Purposely',
        msgTag: 'App',
        msgTime: '10:42 AM',
        msgText: 'Hey team 👋 New shift matched to your interests: <strong>Vancouver Food Bank — Friday 2pm</strong>. 8 spots left.',
        btn1: "✓ I'm in",
        btn2: 'Maybe',
        btn3: 'See details',
        reminderTitle: 'Reminder sent to 6 teammates',
        reminderSub: 'Auto-DM · 24h before shift',
      },
    },
    teams: {
      name: 'Microsoft Teams',
      status: 'Live',
      headline: 'Channel posts and reminders — built native for Teams',
      desc: 'Bring Purposely into your existing Teams channels with full Adaptive Card support. The bot posts matched events, collects RSVPs, and sends personal chat reminders so nothing falls through the cracks.',
      features: [
        'Channel-aware: post to a single team or your whole org',
        'Personal chat reminders',
        'Microsoft Entra (Azure AD) SSO & admin controls',
      ],
      cta: 'Add to Teams →',
      visual: {
        channel: 'CSR Team › General',
        meta: 'Posted by Purposely · 9:14 AM',
        cardTitle: '3 shifts open this week — matched to your team',
        row1: { label: '🥫 Union Gospel — Meal prep', val: 'Wed · 6 spots' },
        row2: { label: '🌱 Stanley Park cleanup', val: 'Sat · 12 spots' },
        row3: { label: '📚 DLS reading mentor', val: 'Fri · 4 spots' },
        btn1: '✓ RSVP',
        btn2: 'Add to calendar',
      },
    },
    faq: {
      heading: 'Setup & Security',
      items: [
        {
          q: 'How long does it take to install?',
          a: "Under two minutes. A workspace admin clicks \"Add to Slack\" or \"Add to Teams,\" approves the OAuth scopes, picks the channels Purposely should post to, and you're live.",
        },
        {
          q: 'What permissions does Purposely request?',
          a: "Read user identity, post to channels you authorize, and send DMs to opted-in users. We never read message history outside our own bot conversations, and we never post on behalf of a user.",
        },
        {
          q: 'Can employees opt out of DM reminders?',
          a: 'Yes — every Purposely DM has a one-click "mute reminders" option, and admins can set org-wide defaults for cadence and quiet hours.',
        },
      ],
    },
    cta: {
      heading_main: 'Ready to put volunteering',
      heading_em: 'on autopilot?',
      sub: 'Book a 20-minute demo and we\'ll connect your workspace live.',
      button: 'Book a demo →',
    },
  },
}
